import { render, staticRenderFns } from "./TerminalDisplayGroup.vue?vue&type=template&id=c53dfb1e"
import script from "./TerminalDisplayGroup.vue?vue&type=script&lang=js"
export * from "./TerminalDisplayGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports